export const manufacturerList = "MANUFACTURER_LIST";